import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { SYSTEM_ALLOWED_DATA_SOURCES } from './dataSourcePolicy.js';
import { PLAN } from '../types/plan.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for Plan entity (global commercial packages).
 * Stored in `plan`. Spec 0038 §3.2 / request 0148.
 */
export const planDescriptor = {
    name: PLAN,
    label: 'Plano',
    domain: 'modules',
    collectionPath: 'plan',
    version: 1,
    description: 'Commercial package of modules contracted by organizations',
    repositoryConfig: {
        dataSource: DataSourceStrategy.Firestore,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: SYSTEM_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique plan identifier',
        },
        {
            name: 'name',
            label: 'Nome',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Plan display name',
        },
        {
            name: 'description',
            label: 'Descrição',
            type: 'string',
            required: false,
            description: 'Plan description',
        },
        {
            name: 'moduleIds',
            label: 'IDs dos Módulos',
            type: 'array',
            arrayItemType: 'string',
            required: false,
            description: 'Base module ids included explicitly',
        },
        {
            name: 'tags',
            label: 'Tags',
            type: 'array',
            arrayItemType: 'string',
            required: false,
            description: 'Classification tags that dynamically include matching modules',
        },
        {
            name: 'billingType',
            label: 'Tipo de Cobrança',
            type: 'string',
            required: false,
            description: 'Billing type for this plan',
        },
        {
            name: 'value',
            label: 'Valor',
            type: 'number',
            required: false,
            description: 'Monetary value of the plan',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [...AUDIT_FOREIGN_KEYS],
};
//# sourceMappingURL=plan.descriptor.js.map